// InstaPass Clerk app (same one the mobile app uses). Publishable keys are public by design.
// Set REACT_APP_CLERK_PUBLISHABLE_KEY at build time; while it is empty the site keeps
// email + password only and no Clerk code runs.
export const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || "";
